import classNames from "classnames";
import { ComponentPropsWithoutRef, forwardRef } from "react";

import Error from "./Error";
import Label from "./Label";

export type Props = {
  name: string;
  label?: string;
  errorMessage?: string;
  endAdornment?: React.ReactNode;
} & Omit<ComponentPropsWithoutRef<"input">, "id" | "name">;

const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      type = "text",
      placeholder,
      label,
      errorMessage,
      endAdornment,
      className,
      disabled,
      ...rest
    },
    ref,
  ) => (
    <div className={classNames("flex flex-col mb-4", className)}>
      {label && <Label htmlFor={name} text={label} />}
      <div className="relative flex items-center">
        <input
          {...rest}
          name={name}
          ref={ref}
          disabled={disabled}
          className={classNames(
            "border rounded-md py-2 pl-3 pr-10 text-white bg-faux-police-blue focus:outline-none focus:ring focus:border-blue-500 w-full",
            {
              "opacity-50 bg-gray-500 border-gray-400": disabled,
            },
          )}
          placeholder={placeholder}
          type={type}
        />
        {endAdornment && (
          <div className="absolute right-3 flex items-center">
            {endAdornment}
          </div>
        )}
      </div>
      <div className="h-3">{errorMessage && <Error text={errorMessage} />}</div>
    </div>
  ),
);

Input.displayName = "Input";

export default Input;
